export const registrationTypes = [
    { value: "BRN", label: "BRN" },
    { value: "NRIC", label: "NRIC" },
    // { value: "ARMY", label: "ARMY" },
    { value: "PASSPORT", label: "PASSPORT" },
  ];